import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Label,
  CardFooter,
  Button,
} from "reactstrap";
import FooterInfoService from "../../../services/KangarooServices/FooterInfoService";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const FooterInfo = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [filters, setFilters] = useState({
    isActive: "",
    isAddress: "",
    isTextOnly: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  // Delete modal states
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);
  const fetchData = async (currentFilters = debouncedFilters) => {
    try {
      const response = await FooterInfoService.getList({
        ...currentFilters,
      });
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  // debounce filters
  useEffect(() => {
    const t = setTimeout(() => setDebouncedFilters(filters), 500);
    return () => clearTimeout(t);
  }, [filters]);

  // refetch on debounced filter update
  useEffect(() => {
    fetchData();
  }, [debouncedFilters]);

  const handleActiveChange = (e) =>
    setFilters((prev) => ({ ...prev, isActive: e.target.value }));
  const handleAddressChange = (e) =>
    setFilters((prev) => ({ ...prev, isAddress: e.target.value }));
  const handleTextChange = (e) =>
    setFilters((prev) => ({ ...prev, isTextOnly: e.target.value }));

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await FooterInfoService.delete(selectedDeleteItem);
        fetchData();
        toast.success("Blog deleted successfully");
      } catch (error) {
        toast.error("Delete failed");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Footer Info Section" pageTitle="Settings" />

        <Row className="mb-4 align-items-end">
          <Col md={3}>
            <Label className="form-label">Active Status</Label>
            <Input
              type="select"
              value={filters.isActive}
              onChange={handleActiveChange}
            >
              <option value="">Select Status</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Input>
          </Col>

          <Col md={3}>
            <Label className="form-label">Address Available</Label>
            <Input
              type="select"
              value={filters.isAddress}
              onChange={handleAddressChange}
            >
              <option value="">Select Option</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </Input>
          </Col>

          <Col md={3}>
            <Label className="form-label">Text Only</Label>
            <Input
              type="select"
              value={filters.isTextOnly}
              onChange={handleTextChange}
            >
              <option value="">Select Option</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </Input>
          </Col>
          <Col>
            <div className="d-flex justify-content-end align-content-end">
              <button
                className="btn btn-success"
                onClick={() => navigate("/footer-info/create")}
              >
                <i className="bi bi-plus-lg me-1"></i> Create
              </button>
            </div>
          </Col>
        </Row>

        <Row className="g-3">
          {data?.map((item, index) => (
            <Col sm={6} xl={4} key={item.id || index}>
              <Card className="h-100 shadow-sm border-0 rounded-3 hover-translate transition p-3">
                <CardHeader className="bg-light border-0 rounded-2 mb-2">
                  <h6 className="fw-bold mb-1">{item?.name || "-"}</h6>
                  {item?.email && (
                    <p className="mb-1 text-muted small">{item.email}</p>
                  )}
                  {item?.phone && (
                    <p className="mb-1 text-muted small">{item.phone}</p>
                  )}
                  {item?.address && (
                    <p className="mb-0 text-muted small">{item.address}</p>
                  )}
                </CardHeader>

                <CardBody className="pt-2 d-flex flex-column justify-content-between">
                  <div className="mb-2">
                    {item?.isActive !== undefined && (
                      <span
                        className={`badge ${
                          item.isActive ? "bg-success" : "bg-danger"
                        } me-1`}
                      >
                        {item.isActive ? "Active" : "Inactive"}
                      </span>
                    )}
                    {item?.isTextOnly && (
                      <span className="badge bg-info">
                        {item.isTextOnly ? "Text Only" : ""}
                      </span>
                    )}
                  </div>

                  {!item?.isTextOnly && (
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {Object.keys(item).map((key) => {
                        if (key.endsWith("Image")) {
                          const imageObj = item[key];
                          const urlKey = key.replace("Image", "Url");
                          const url = item[urlKey];
                          if (!imageObj?.url || !url) return null;

                          return (
                            <a
                              key={key}
                              href={url}
                              target="_blank"
                              rel="noopener noreferrer"
                              title={urlKey.replace("Url", "")}
                              className="social-icon"
                            >
                              <img
                                src={`${imageBaseApi}${imageObj.url}`}
                                alt={urlKey.replace("Url", "")}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                  borderRadius: "50%",
                                  border: "1px solid #eee",
                                }}
                              />
                            </a>
                          );
                        }
                        return null;
                      })}
                    </div>
                  )}
                </CardBody>
                <CardFooter>
                  <div className="d-flex justify-content-end gap-2 align-content-center ">
                    <Button
                      size="sm"
                      color="primary"
                      className="me-2 rounded-pill"
                      onClick={() => navigate(`/footer-info/update/${item.id}`)}
                    >
                      <i className="bx bx-edit-alt"></i>
                    </Button>

                    <Button
                      size="sm"
                      color="danger"
                      className="rounded-pill"
                      onClick={() => handleDeleteClick(item.id)}
                    >
                      <i className="ri-delete-bin-5-line"></i>
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default FooterInfo;
